module.exports = __webpack_public_path__ + "img/busmile.c19d36d8.gif";